import { useState, useEffect } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { authFormShell } from './utils/forms';
import { authenticate } from './utils/functions';
import { useAuth } from '../context/AuthContext';

const Auth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authForm, setAuthForm] = useState(authFormShell);
  const [isLogin, setIsLogin] = useState(location.pathname === '/login');
  const [error, setError] = useState('');
  const { login } = useAuth();

  useEffect(() => {
    setIsLogin(location.pathname === '/login');
  }, [location.pathname]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAuthForm({
      ...authForm,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { token, success } = await authenticate(isLogin, authForm, setAuthForm, setError);
      if (success && token) {
        login(token);
        navigate('/cats');
      }
    } catch (err) {
      console.error('Authentication error:', err);
    }
  };

  return (
    <div>
      <h1>Welcome to Chelsea's Treasure Trove!</h1>
      <h2>Log in or register</h2>
      <h3>{isLogin ? 'Login' : 'Registration'}</h3>
      <form onSubmit={handleSubmit}>
        {!isLogin && (
          <div>
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={authForm.email}
              onChange={handleChange}
              required
            />
          </div>
        )}
        <div>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={authForm.username}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={authForm.password}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">{isLogin ? 'Login' : 'Register'}</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
        {isLogin && (
          <br/>
        )}
      <p>
        {isLogin ? (
          <>
            {`Don't have an account?`} <Link to="/register">Register here</Link>
          </>
        ) : (
          <>
            Already have an account? <Link to="/login">Login here</Link>
          </>
        )}
      </p>
    </div>
  );
};

export default Auth;
